import { createSelector } from 'reselect';
import { constants as marketConstants } from '@clearscore/redux.market';

import getCurrentPath from './getCurrentPath';

const containsMarketPath = (state) =>
    getCurrentPath(state, null)
        .split('/')
        .find((path) => marketConstants.MARKETS.includes(path));

export default createSelector(containsMarketPath, (marketPath) => marketPath);
